import { Editors } from "../../interfaces/common";
import StoreState from "../../interfaces/store/storeState";
import { Selector } from "./selectorType";

export const selectEditors: Selector<Editors> = (({serviceProperties: {editors}}: StoreState): Editors => editors);

export const selectCtWebExtensionUrl: Selector<string> = (({
    serviceProperties: {ctWebExtensionUrl},
}: StoreState): string => ctWebExtensionUrl);
